import { useEffect, useState } from 'react';

export const useHeaderSize = () => {
  const header = document.getElementById('header');
  const headerOffsetTop = 7;
  const [headerSize, setHeaderSize] = useState({
    height: header ? header.offsetHeight + headerOffsetTop : 0,
    width : header ? header.offsetWidth : 0
  });

  useEffect(() => {
    const offsetHeight = header.offsetHeight + headerOffsetTop;
    const offsetWidth  = header.offsetWidth;

    const onResize = () => {
      setHeaderSize({
        height: offsetHeight,
        width : offsetWidth
      })
    };

    window.addEventListener('load', onResize);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    return () => {
      window.removeEventListener('load', onResize);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [
    headerSize,
    setHeaderSize
  ];
};
